import React from 'react';
import Axis from './Axis';
import { Scales, Margins, SvgDimensions, Data, Tick } from './index';

type Props = {
  scales: Scales;
  margins: Margins;
  svgDimensions: SvgDimensions;
  unit: string;
  location: string;
  timeframe: string;
  sum?: number;
  data: Data;
  tick?: Tick;
  type: 'temperature' | 'production' | 'consumption';
  showTemperatureData: boolean;
  contractFromId: { address: string };
};

const Axes: React.FunctionComponent<Props> = (props: Props) => {
  const {
    scales,
    margins,
    svgDimensions,
    unit,
    type,
    showTemperatureData,
  } = props;

  const { width } = svgDimensions;

  // allow modification for downwards-pointing bars
  let verticalScale; // ScaleLinear<number, number, never>;
  let translateYAxis = '';

  const tempUnit = `°C`;

  if (type === 'production') {
    verticalScale = scales.yScale2;
    translateYAxis = `translate(${margins.left}, ${margins.bottom * -1 + 10})`;
  } else if (type === 'temperature') {
    verticalScale = scales.yScale3;
    translateYAxis = `translate(0, 0)`;
  } else {
    verticalScale = scales.yScale;
    translateYAxis = `translate(${margins.left}, 0)`;
  }

  return (
   <>
      {type === 'consumption' &&
      <g>
        <text className="graph-unit" textAnchor="start" x="20" y="20">
              {unit}
        </text>
        <Axis
        orient={'Left'}
        scale={verticalScale}
        tickSize={width - margins.left - margins.right}
        translate={translateYAxis}
        type={type}
        />
      </g>
        }
      {showTemperatureData && type === 'temperature' && (
        <g>
          <text className="graph-unit" textAnchor="start" x="20" y="20">
            {tempUnit}
          </text>
          <Axis
            orient={'Right'}
            scale={verticalScale}
            tickSize={width - margins.left - margins.right}
            translate={translateYAxis}
            type={type}
          />
       </g>
      )}


      {type === 'production' &&
      <g>
        <text className="graph-unit" textAnchor="start" x="20" y="330">
          {unit}
        </text>
        <Axis
        orient={'Left'}
        scale={verticalScale}
        tickSize={width - margins.left - margins.right}
        translate={translateYAxis}
        type={type}
        />
      </g>
        }
   </>
  );
};

export default Axes;
